<!--
    描述：快捷菜单子菜单--- 我的委托
    时间：2021-03-26
    Created by 王帅
    Edit by zl
-->
<template>
	<div class="Commission-layout primary-layout filter-layout">
		<div class="filter-box mb30">
			<el-row :gutter="15"
					v-show="searchToggle">
				<el-form ref="elForm"
						 :model="formData"
						 size="small"
						 label-width="120px">
					<el-col :span="6">
						<el-form-item label="委托单号"
									  prop="orderNo">
							<el-input v-model="formData.orderNo"
									  placeholder="请输入单行文本委托单号"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="委托审计单位"
									  prop="sponsorUnit">
							<el-input v-model="formData.sponsorUnit"
									  placeholder="请输入委托审计单位名称（全称或简称）">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="委托单位类型"
									  prop="unitType">
							<el-select v-model="formData.unitType"
									   placeholder="请选择审计任务类型">
								<el-option label="协审单位"
										   value="0"></el-option>
								<el-option label="审计单位"
										   value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="审计任务类型"
									  prop="taskType">
							<el-select v-model="formData.taskType"
									   placeholder="请选择审计任务类型">
								<el-option v-for="(item, index) in projectDict.sjrwlx"
										   :key="'taskType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="工程项目名称"
									  prop="proName">
							<el-input v-model="formData.proName"
									  placeholder="请输入工程项目名称">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="项目类型"
									  prop="proType">
							<el-select v-model="formData.proType"
									   placeholder="请选择项目类型">
								<el-option v-for="(item, index) in projectDict.xmlx"
										   :key="'proType' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="标段编号"
									  prop="packNo">
							<el-input v-model="formData.packNo"
									  placeholder="请输入标段编号">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="标段名称"
									  prop="packName">
							<el-input v-model="formData.packName"
									  placeholder="请输入标段名称">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="委托日期"
									  prop="dateTime">
							<el-date-picker type="daterange"
											v-model="formData.dateTime"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											@change="timeChange"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="状态">
							<el-select v-model="status"
									   placeholder="请选择状态"
									   :disabled="activeName == '1'"
									   @change="statusChange">
								<el-option v-for="(item, index) in statusList"
										   :key="'status' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12"
							class="text-right">
						<el-form-item>
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="searchForm">查询</el-button>
							<el-button @click="resetForm"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>

			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="searchToggle = !searchToggle">
				{{ searchToggle ? '点击收起' : '筛选' }}
				<svg-icon :icon-class="searchToggle ? 'pack-up' : 'pack-down'"
						  class="c-icon ml5"></svg-icon>
			</div>
		</div>
		<div class="primary-content">
			<div class="primary-header mb5">
				<div class="left-tabs">
					<el-tabs v-model="activeName"
							 @tab-click="tabClick">
						<el-tab-pane label="委托办理中"
									 name="0"></el-tab-pane>
						<el-tab-pane label="作废记录"
									 name="1"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="btnGroups">
<!--					 <el-button size="small"
							   @click="exportExcel">导出Excel</el-button>-->
					<el-button icon="el-icon-menu"
							   type="primary"
							   size="small"
							   @click="doFilter">列过滤</el-button>
				</div>
			</div>
			<div class="primary-container"
				 v-loading="loading">
				<CustomTableVxe v-if="tableShow"
								ref="projectTable"
								:requestConfigUrl="CustomTableVxeData.requestConfigUrl"
								:requestDataUrl="CustomTableVxeData.requestDataUrl"
								:btnEvent="CustomTableVxeData.btnEvent"
								:config="CustomTableVxeData.table.config"
								:data="CustomTableVxeData.table.data"
								:page="CustomTableVxeData.table.page"
								@page-change="pageListen">
					<div slot="委托单号"
						 slot-scope="scope">
						<span class="vxe-cell--label">{{ scope.row.orderNo }}</span>
						<template v-if="getSectionStatus(scope.row.status) != ''">
							<el-tooltip :content="scope.row.reason"
										:disabled="scope.row.reason == ''"
										popper-class="bm-tooltip tooltipWidth"
										placement="right">
								<svg-icon class="section-icon ml10"
										  :icon-class="getSectionStatus(scope.row.status)"></svg-icon>
							</el-tooltip>
						</template>
					</div>
					<div slot="委托审计单位"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.assitantUnitName"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.assitantUnitShortName }}</span>
						</el-tooltip>
					</div>
					<div slot="委托日期"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.reportDate"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.reportDate.substr(0, 11) }}</span>
						</el-tooltip>
					</div>
					<div slot="报审日期"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.reportDate"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.reportDate.substr(0, 11) }}</span>
						</el-tooltip>
					</div>
					<div slot="建设单位"
						 slot-scope="scope">
						<el-tooltip effect="dark"
									:content="scope.row.ownerUnitName"
									placement="top">
							<span class="vxe-cell--label">{{ scope.row.ownerUnitShortName }}</span>
						</el-tooltip>
					</div>
					<div slot="委托方式"
						 slot-scope="scope">
						<span class="vxe-cell--label"
							  v-if="scope.row.entrustType == 0">自行委托</span>
						<span class="vxe-cell--label"
							  v-else-if="scope.row.entrustType == 1">委托审计机关</span>
						<span class="vxe-cell--label"
							  v-else>-</span>
					</div>
					<template slot="状态"
							  slot-scope="scope">
						<span :class="dealClass(scope.row.status)">
							{{ scope.row.statusName }}
						</span>
					</template>
				</CustomTableVxe>
			</div>
		</div>

		<!-- 修改、撤回 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.show"
				   center
				   append-to-body
				   :close-on-click-modal="false"
				   :width="dialogObj.width"
				   @close="doCancel">
			<template v-if="dialogObj.type == 'edit'">
				<div v-if="selectObj.status == '1001026004'">
					<p class="mt20 mb30 font16">委托报审已被撤回！请确认是否前往修改！</p>
					<p>
						撤回原因：
					<p class="mt15">{{ selectObj.reason }}</p>
					</p>
				</div>
				<el-row v-else>
					<el-col :span="12"
							class="mb30">
						<span>{{ selectObj.status == '1001026007' ? '退审单位：' : '审核人： ' }}</span>
						{{ selectObj.status == '1001026007' ? selectObj.assitantUnitName : selectObj.updateUserName }}
					</el-col>
					<el-col :span="12"
							class="mb30">
						<span>{{ selectObj.status == '1001026007' ? '退审时间：' : '审核时间：' }}</span>
						{{ selectObj.backDate }}
					</el-col>
					<el-col :span="24"
							class="mt15 mb30">
						<p class="mb10">
							{{ selectObj.status == '1001026007' ? '退审原因：' : '审核意见：' }}
						</p>
						{{ selectObj.reason }}
					</el-col>
				</el-row>
			</template>
			<template v-if="dialogObj.type == 'del' || dialogObj.type == 'giveUp'">
				<p class="mb5"
				   v-if="dialogObj.type == 'giveUp'">请确认是否需要作废，并填写作废原因</p>
				<el-form ref="recallForm"
						 :model="recallForm"
						 class="mb30">
					<el-form-item :label="'请填写' + dealType(dialogObj.type) +'原因'"
								  prop="reason"
								  :rules="requiredRule">
						<el-input type="textarea"
								  :autosize="{ minRows: 4 }"
								  maxlength="200"
								  show-word-limit
								  v-model="recallForm.reason"></el-input>
					</el-form-item>
				</el-form>
				<p class="tip"
				   v-if="dialogObj.type == 'del'">
					<i class="el-icon-warning"></i> 备注：撤回后，流程审核任务会被取消，将不会再继续往下走审核流程
				</p>
				<p v-if="dialogObj.type == 'giveUp'"
				   class="tip">
					<i class="el-icon-warning"></i> 备注：作废后，可在作废记录里面查看作废记录
				</p>
			</template>
			<template v-if="dialogObj.type == 'details'">
				<el-row :gutter="10">
					<el-form :model="detailForm"
							 label-width="120px"
							 size="small"
							 class="detail-from-commission"
							 ref="detailForm">
						<el-col :span="12">
							<el-form-item label="工程项目名称：">
								{{ detailForm.sname }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="项目类型：">
								{{ detailForm.proType }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="标段编号：">
								{{ detailForm.packNo }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="标段名称：">
								{{ detailForm.packName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="委托单号：">
								{{ detailForm.orderNo }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="委托日期：">
								{{ detailForm.reportDate }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="委托方式：">
								{{ detailForm.entrustType ? '委托审计机关' : '自行委托' }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="委托审计单位：">
								{{ detailForm.assitantUnitName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="委托单位类型：">
								{{ detailForm.unitTypeName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="审计任务类型：">
								{{ detailForm.taskTypeName }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<p class="line-split"></p>
						</el-col>
						<el-col :span="12">
							<el-form-item label="操作人：">
								{{ detailForm.updateUserName }}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="操作时间：">
								{{ detailForm.backDate }}
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="作废原因：">
								{{ detailForm.reason }}
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
			</template>
			<div slot="footer">
				<el-button class="btn"
						   @click="doCancel">{{ activeName == '0' ? '取消' : '关闭' }}</el-button>
				<el-button class="btn btn-blue"
						   @click="doSubmit(dialogObj.type)"
						   v-if="activeName == '0'">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 列过滤弹窗 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  leftWidth="160px"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import ConfigJson from './config.json'
import { mapState } from 'vuex'
import * as API from 'api/Commission/commission'
import { getAuditWorkPower } from 'api/home/homeIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { getStatusStyle } from 'utils/tools.js'
import axios from 'axios'

export default {
	name: 'CommissionIndex',
	components: {
		ColumnFilter,
	},
	data() {
		return {
			activeName: '0',
			formData: {
				size: 10,
				current: 1,
				orderNo: '', //委托单号
				dateTime: [], //委托日期
				startDate: '', //报审日期（开始）
				endDate: '', //报审日期（结束）
				unitType: '', //委托单位类型
				status: '', //状态
				sponsorUnit: '', //委托单位
				taskType: '', //审计任务类型
				proName: '', //工程项目名称
				proType: '', //项目类型
				packNo: '', //标段编号
				packName: '', //标段名称
				tenantId: '',
			},
			status: '',
			searchToggle: true, //筛选
			tableShow: true, //表格显示
			dialogObj: {
				title: '',
				show: false,
				type: '',
				width: '800px',
			},
			historyData: [], //审批流程
			recallForm: {
				reason: '', //撤回原因
			},
			requiredRule: [
				{ required: true, message: '不能为空...', trigger: 'blur' },
			],
			detailForm: {
				sname: '',
				remark: '',
				status: 1,
				updateDate: '',
			},
			loading: false,
			CustomTableVxeData: {
				requestConfigUrl: '',
				requestDataUrl: '',
				btnEvent: [],
				table: {
					config: {},
					page: {
						currentPage: 1,
						pageSize: 10,
						total: 20,
					},
					data: [],
				},
			},
			selectObj: {},
			rowId: '', // 点中行的id
			tagObj: {
				width: '800px',
				show: false,
				type: 'add',
				name: '',
			},
			// 列过滤对象数组
			showFilter: false,
			filterColumns: [
				{
					title: '委托办理中',
					checkAll: false,
					columns: [],
				},
				{
					title: '作废记录',
					checkAll: false,
					columns: [],
				},
			],
		}
	},
	created() {
		this.CustomTableVxeData.btnEvent = this.toEntrustBtn
		this.CustomTableVxeData.table.config =
			ConfigJson.Commission.project_to_entrust
		this.formData.tenantId = this.tenantId
		this.getData()

		// 列过滤对象数组
		this.$set(
			this.filterColumns[0],
			'columns',
			ConfigJson.Commission.project_to_entrust.column
		)
		this.$set(
			this.filterColumns[1],
			'columns',
			ConfigJson.Commission.project_invalid.column
		)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			if (this.$refs.projectTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)

				this.$refs.projectTable.refreshColumn()
			}
		},

		// 获取委托列表
		getData() {
			this.loading = true
			this.tableShow = false
			let params = Object.assign({}, this.formData)
			let xTable = this.CustomTableVxeData.table
			API.selectPagEentrust(params)
				.then((res) => {
					if (this.formData.size != -1) {
						xTable.page.total = parseInt(res.data.total)
					} else {
						xTable.page.total = parseInt(res.data.records.length)
					}
					setTimeout(() => {
						xTable.data = res.data.records
						this.loading = false
						this.tableShow = true
					}, 50)
				})
				.catch(() => {
					xTable.data = []
					xTable.page.total = 0
					this.tableShow = true
					this.loading = false
				})
		},

		// 搜索
		searchForm() {
			this.formData.current = 1
			this.CustomTableVxeData.table.page.currentPage = 1
			this.getData()
		},

		// 重置
		resetForm() {
			this.$refs.elForm.resetFields()
			this.formData.startDate = ''
			this.formData.endDate = ''
			this.status = ''
			this.activeName != '1' ? (this.formData.status = '') : ''
			this.searchForm()
		},

		// 查看/修改/撤回
		doClick(data, type, title) {
			this.dialogObj.show = true
			this.dialogObj.type = type
			this.dialogObj.title = title
			this.selectObj = data
			if (type == 'view') {
				// 储存当前菜单
				let obj = {
					meta: this.$route.meta,
					path: this.$route.path,
					name: this.$route.name,
				}
				this.$setSessionItem('activeMenu', JSON.stringify(obj))
				this.$setSessionItem('currentRow', JSON.stringify(data))
				this.dialogObj.show = false
				let queryParams = {
					menu: 'commission',
					active: this.activeName,
					type: 'view',
					projectId: data.projectId,
				}
				this.$router.push({
					name: 'AuditLook',
					query: queryParams,
				})
			} else if (type == 'details') {
				this.detailForm = data
			}
		},

		// 弹框取消
		doCancel() {
			this.dialogObj.show = false
			this.dialogObj.type = ''
			this.dialogObj.title = ''
			this.recallForm.reason = ''
			this.detailForm = {}
		},

		// 弹框确认
		doSubmit(type) {
			if (type == 'edit') {
				let obj = {
					meta: {
						title: '项目管理',
					},
					name: 'ProjectIndex',
					path: '/projectManagement',
				}
				this.$setSessionItem('activeMenu', JSON.stringify(obj))
				this.$setSessionItem(
					'projectRow',
					JSON.stringify(this.selectObj)
				)
				this.$router.push({
					path: '/entrust',
					query: {
						type: 'commission',
					},
				})
			} else {
				this.$refs.recallForm.validate((valid) => {
					if (valid) {
						let status = ''
						type == 'del'
							? (status = '1001026004')
							: (status = '1001026005')
						API.getWithdrawAdd({
							id: this.selectObj.id,
							status,
							remark: this.recallForm.reason,
						}).then((res) => {
							if (res.operationCode != 1 || res.msg == 'faild') {
								this.btnLoading = false
								this.$message.error(res.data)
								return
							}
							this.$message.success(res.msg)
							this.dialogObj.show = false
							this.getData()
						})
					}
				})
			}
		},

		// 分页监听
		pageListen(obj) {
			this.formData.current = obj.currentPage
			this.formData.size = obj.pageSize
			this.getData()
		},

		// tab点击
		tabClick(data) {
			let name = data.name
			this.tableShow = false
			let xTable = this.CustomTableVxeData
			this.formData.status = ''
			this.formData.size = 10
			this.CustomTableVxeData.table.page.pageSize = 10
			if (name == '0') {
				xTable.btnEvent = this.toEntrustBtn
				xTable.table.config = ConfigJson.Commission.project_to_entrust
			} else if (name == '1') {
				this.status = ''
				this.formData.status = '1001026005'
				xTable.btnEvent = this.invalidBtns
				xTable.table.config = ConfigJson.Commission.project_invalid
			}
			setTimeout(() => {
				this.tableShow = true
				this.searchForm()
			}, 100)
		},

		// 时间处理
		timeChange(data) {
			this.formData.startDate = data[0]
			this.formData.endDate = data[1]
		},

		// 状态change事件
		statusChange(data) {
			this.formData.status = data
		},

		// 导出excel
		exportExcel() {
		  //获取列过滤的数据
      var fileds=this.filterColumns[0].columns;
      //符合设定 序号不参与列过滤
		  var arr=[{
        name: '序号',
        field: 'seq',
        isCheck: true
      }];
		  //组装后台需要的数据格式
		  fileds.forEach(f=>{
		    arr.push( {
          name: f.title,
          field: f.field,
          isCheck: f.visible
        })
      })
      //获取查询条件
			let obj = this.$utils.clone(this.formData, true)
      //这里是控制是否根据列过滤导出 0 不是 1 是
      obj.isAllExport='1';
		  obj.exportExcleHeader=arr;
      axios.post(process.env.VUE_APP_BASE_URL +'busTaskAudit/entrustTaskInfoExcel',
          obj,
          {responseType: 'arraybuffer'}).then(res => {
        // 获取文件名  这里是后台使用了cache-control 放文件名称  Content-Disposition  axios不接受
        const fileName = decodeURI(
            res.headers['cache-control'].split('=')[1]
        )
        const link = document.createElement('a');  // 创建元素
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);   // 创建下载的链接
        //num++
        link.setAttribute('download', fileName);  // 给下载后的文件命名
        document.body.appendChild(link);
        link.click();  // 点击下载
        document.body.removeChild(link);  //  下载完成移除元素
        window.URL.revokeObjectURL(link.href);  // 释放掉blob对象
      })
		},

		// 获取标段报审状态
		getSectionStatus(status) {
			let icon = ''
			// 0：未提交报审;  1：已提交报审;  2：报审内部审核通过; 3：提交报审被驳回; 4：撤回; 5：提交报审被退回; 6：已受理
			switch (status) {
				case '1001026003':
					icon = 'section-refuse'
					break
				case '1001026004':
					icon = 'section-cancel'
					break
				case '1001026005':
					icon = 'section-giveup'
					break
				case '1001026007':
					icon = 'section-return'
					break
				default:
					icon = ''
			}

			return icon
		},

		// 处理类型
		dealType(data) {
			let msg = ''
			if (data == 'giveUp') {
				msg = '作废'
			} else {
				msg = '撤回'
			}
			return msg
		},

		// 处理样式
		dealClass(data) {
			let msg = getStatusStyle(data)
			return msg
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			tenantId: (state) => state.tenantId,
			userInfo: (state) => state.userInfo,
		}),
		toEntrustBtn() {
			let btns = [
				{
					name: '查看',
					icon: '',
					renderIcon: 'form-look',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('view')
					},
					click: (data) => {
						this.doClick(data, 'view', '查看')
					},
				},
				{
					name: '修改',
					icon: '',
					renderIcon: 'form-edit',
					disabled: (data) => {
						let pass = '1001026003,1001026004,1001026007'
						return !pass.includes(data.status)
					},
					show: (data) => {
						return this.roleBtns.includes('edit')
					},
					click: (data) => {
						let msg = ''
						switch(data.status){
							case '1001026003':
								msg = '修改--被驳回'
								break
							case '1001026004':
								msg = '修改--撤回'
								break
							case '1001026007':
								msg = '修改--被退审'
								break
						}
						this.doClick(data, 'edit', msg)
					},
				},
				{
					name: '撤回',
					icon: '',
					renderIcon: 'form-chehui',
					disabled: (data) => {
						return data.status != '1001026001'
					},
					show: (data) => {
						return this.roleBtns.includes('recall')
					},
					click: (data) => {
						this.doClick(data, 'del', '撤回')
					},
				},
				{
					name: '作废',
					icon: '',
					renderIcon: 'form-zuofei',
					disabled: (data) => {
						let pass = '1001026003,1001026004,1001026007'
						return !pass.includes(data.status)
					},
					show: (data) => {
						return this.roleBtns.includes('giveUp')
					},
					click: (data) => {
						this.doClick(data, 'giveUp', '作废')
					},
				},
				{
					name: '进入项目',
					icon: '',
					renderIcon: 'form-enter',
					disabled: (data) => {
						let pass = '1001026001,1001026003,1001026004'
						return pass.includes(data.status)
					},
					show: (data) => {
						return this.roleBtns.includes('getInItem')
					},
					click: (data) => {
						let url = this.$outUrl
						let token = this.$getSessionItem('token')
						let tenantId = this.$getSessionItem('tenantId')
						let limitId = this.$getSessionItem('limitId')
						getAuditWorkPower({
							projectId: data.projectId,
						}).then((res) => {
							if (res.data.constructor == String) {
								this.$message.warning(res.data)
							} else {
								window.open(
									`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId==null?'':tenantId}&limitId=${limitId==null?'':limitId}&isDataRole=${res.data}`,
									'_blank'
								)
							}
						})
					},
				},
			]
			return btns
		},
		invalidBtns() {
			let btns = [
				{
					name: '详情',
					icon: '',
					renderIcon: 'form-detail',
					disabled: (data) => {
						return false
					},
					show: (data) => {
						return this.roleBtns.includes('details')
					},
					click: (data) => {
						this.doClick(data, 'details', '详情')
					},
				},
			]
			return btns
		},
		statusList() {
			let list = [
				{
					sname: '审核中',
					value: '1001026001',
				},
				{
					sname: '己撤回',
					value: '1001026004',
				},
				{
					sname: '内部审核通过',
					value: '1001026002',
				},
				{
					sname: '内部审核被驳回',
					value: '1001026003',
				},
				{
					sname: '委托已受理',
					value: '1001026006',
				},
				{
					sname: '已退审',
					value: '1001026007',
				},
				{
					sname: '已结项',
					value: '1001026008',
				},
			]
			return list
		},
	},
}
</script>

<style scoped lang="less">
.Commission-layout {
	padding: 30px 20px 5px 20px;
	.filter-box {
		padding-bottom: 15px;
	}
	/deep/ .primary-container {
		height: calc(~'100% - 40px');
	}
}
.mb5 {
	margin-bottom: 5px;
}
.font16 {
	font-size: 16px;
}
.tip {
	padding: 5px 10px;
	background-color: rgba(96, 173, 249, 0.3);
	border: 1px solid #60adf9;
	color: #2f93f8;
}
.section-icon {
	color: #ca0a14;
	margin-right: 3px;
	font-size: 20px;
	vertical-align: sub;
}
.text-color {
	color: #60adf9;
}
.btn {
	padding: 0 50px !important;
}
.detail-from-commission {
	.line-split {
		height: 3px;
		margin: 0 auto 15px auto;
		border-bottom: 1px solid #2671cc;
	}
}
</style>
